import { Component } from '@angular/core';

/** Coquille hôte : barre de titre + détail client bibliothèque. */
@Component({
  selector: 'app-client-detail-shell',
  template: '<app-title-section></app-title-section><router-outlet></router-outlet>'
})
export class ClientDetailShellComponent {}
